module.exports = __webpack_public_path__ + "img/yijianhuojianyi.aad67d27.jpg";